import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "./Contact.css";
import Header from "../../components/Header";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("Sending...");

    emailjs
      .send(
        "intosoundhealing",
        "template_intosound",
        {
          user_name: formData.name,
          user_email: formData.email,
          message: formData.message,
        },
        "ve9evhmbg-alhVjzI"
      )
      .then(() => {
        setStatus("Message sent!");
        setFormData({ name: "", email: "", message: "" });
      })
      .catch((error) => {
        console.error("EmailJS error:", error);
        setStatus("Failed to send message. Try again.");
      });
  };

  const isDisabled = !formData.name || !formData.email || !formData.message;

  return (
    <div>
      <Header />
      <div className="contact-container">
        <div className="contact-section">
          <h2>Contact Me</h2>
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <label>
                Name<span className="required">*</span>:
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>
                Email<span className="required">*</span>:
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>
                Message<span className="required">*</span>:
              </label>
              <textarea
                name="message"
                rows="6"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </div>
            <button type="submit" disabled={isDisabled}>
              Send
            </button>
            <p className="status">{status}</p>
          </form>
          <div className="contact-address">
            <h3>Our Mailing Address</h3>
            <p>Into Sound Healing</p>
            <p>2360 Huntington Dr. #336</p>
            <p>San Marino, CA 91108</p>
            <p>United States</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
